<template>
  <div id="s-menu" class="s-base">
    <v-card class="menu-panel s-panel" max-width="1000">
      <span class="menu-title">メニュー</span>
      <v-container>
        <v-row class="menu-list-item" align="center" justify="center">
          <v-col md="7">
            <v-btn
              class="menu-btn"
              color="secondary"
              @click="clickMenu('BulkDownload')"
              v-if="isContractingBulkDelivery === true"
              >一括配信データ</v-btn
            >
          </v-col>
        </v-row>

        <v-row class="menu-list-item" align="center" justify="center">
          <v-col md="7">
            <v-btn
              class="menu-btn"
              color="secondary"
              @click="clickMenu('PasswordSetting')"
              >パスワード設定</v-btn
            >
          </v-col>
        </v-row>

        <v-row class="menu-list-item" align="center" justify="center">
          <v-col md="7">
            <v-btn
              class="menu-btn"
              color="secondary"
              @click="clickMenu('ManualProviding')"
              >操作マニュアル</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
      <v-card-title class="pt-16 pl-3">お知らせ</v-card-title>
      <v-divider />
      <div class="text-body-1 py-4 px-6">{{ notice }}</div>
    </v-card>
    <request-error-dialog
      :requestErrorDialogFlag.sync="dialog.requestError"
      :httpStatus="httpStatus"
      :contractsInfoExists="contractsInfoExists"
      message=""
    />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { noticeApi } from "../api/NoticeApi";
import { NETWORK_ERROR } from "../router";
import RequestErrorDialog from "./RequestErrorDialog.vue";
import { Contract, userApi } from "../api/UserApi";
import loginModule from "../store/LoginModule";
import Axios from "axios";

@Component({
  components: {
    "request-error-dialog": RequestErrorDialog,
  },
})
export default class Menu extends Vue {
  BULK_CONTRACT_CODE = 3;

  notice = "";

  dialog = {
    requestError: false,
  };

  httpStatus = 500;
  contractsInfoExists = true;

  contracts: Contract[] = [];

  clickMenu(name: string) {
    this.$router.push({ name: name });
  }

  get isContractingBulkDelivery(): boolean {
    if (this.contracts.length === 0) {
      return false;
    }
    const bulkContract = this.contracts.find(
      (contract) => contract.delivCd === this.BULK_CONTRACT_CODE
    );

    if (bulkContract) {
      return true;
    } else {
      return false;
    }
  }

  async loadAllData(): Promise<void> {
    try {
      const result = {
        notice: await noticeApi.getNotice(),
        contract: await userApi.getBulkContract(loginModule.userId, false),
      };

      this.contracts = result.contract.contractResponse.result;
      this.notice = result.notice.noticeResponse.result.notice;
    } catch (error) {
      this.notice = "";
      this.contracts = [];
      let newError: Error;
      if (Axios.isAxiosError(error) && error.response) {
        newError = new Error(error.response.status.toString());
      } else {
        newError = new Error(NETWORK_ERROR);
      }
      if (newError.message === "401") {
        // 401 Unauthorized
        this.httpStatus = 401;
        this.dialog.requestError = true;
      } else if (newError.message === "404") {
        // 404 Not Found
        this.httpStatus = 404;
        this.contractsInfoExists = false;
        this.dialog.requestError = true;
      } else if (newError.message === "500") {
        // 500 Internal Server Error
        this.httpStatus = 500;
        this.dialog.requestError = true;
      } else {
        this.httpStatus = parseInt(newError.message);
        // 運用上起こってはいけないエラー
        await this.$router.push({ name: newError.message });
      }
    }
  }

  async mounted() {
    await this.loadAllData();
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/common.scss";
div#s-menu {
  height: 100%;
}
.menu-panel {
  span.menu-title {
    font-size: 20pt;
    font-weight: 900;
    color: #2b72de;
  }
  .menu-list-panel {
    padding: 4px 24px 4px 24px;
  }
  .menu-list-item {
    padding: 16px 0 0 0;
  }
  .menu-btn {
    width: 100%;
  }
  .menu-btn-info {
    text-align: left;
    font-size: 10.5pt;
  }
}
</style>
